import {makeStyles} from "@material-ui/core/styles";
import {topHeight} from "../../../../stores/NavigateStore";

export const  useStyles = makeStyles((theme) => ({
    root:{
        width: '100%',
        padding: '24px',
        boxSizing: 'border-box',
        marginTop: 54,
        minHeight: 'calc(100vh - 54px)',
    },
    contentBox: {
        height: 'calc(100vh - 170px)',
        overflowY: 'auto',
    },
    emptyBox:{
        width: '100%',
        height: `calc(100vh - ${topHeight}px - 36px - 20px - 24px - 24px)`,
        display:'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& p':{
            fontSize: '1.375rem',
            color: '#87888d',
            fontWeight:400,
            textAlign: 'center',
            lineHeight: '30.36px'
        }
    },
    tableBox:{
        borderRadius: '8px 8px 0 0',
        boxShadow: 'none',
        background:'#fff',
        '&::-webkit-scrollbar': {
            width: '10px',
            height: '10px'
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#6f6f6f',
            borderRadius: '10px',
            backgroundClip: 'padding-box',
            border: '3px solid transparent',
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
            marginTop: 5,
        },
    },
    table: {
        minWidth: 930,
        overflowX:'auto',
    },
    tableHeadStyle:{
        '& th':{
            height: 50,
            padding: '0 10px',
            fontSize: '1rem',
            fontWeight: 700,
            color: '#10121C',
            borderBottom: '1px solid #BCBCBC'
        }
    },
    tableBodyStyle:{
        '& th, td':{
            padding: '13px 10px',
            fontSize: '1rem',
            fontWeight: 400,
            color: '#10121C',
            borderBottom: '1px solid #BCBCBC'
        },
        '& th':{
            fontWeight: 700,
        },
    },
    tableButton:{
        width: 80,
        height:30,
        borderRadius: 4,
        background: '#5579F0',
        padding: 0,
        color: '#fff',
        fontSize: '1rem',
        fontWeight: 700,
        '&:hover':{
            background:'#5579F0'
        }
    },
    sortButton:{
        cursor:'pointer',
        display:'flex',
        alignItems: 'center',
        '& p':{
            fontSize: '1rem',
            fontWeight: 700,
            color: '#10121C',
            marginRight: 4,
            marginLeft: 10,
        }
    },
    paginationBox:{
        '& .MuiToolbar-root':{
            position: 'relative',
        },
        '& .MuiInputBase-root':{
            marginLeft: 0,
            marginRight: 20
        },
        '& .MuiSelect-select':{
            fontSize: '0.75rem',
            color:'#323232',
            paddingRight: 17,
            '&:focus':{
                background:'transparent'
            }
        },
        '& .MuiTablePagination-caption':{
            fontSize: '0.75rem',
            color: '#10121c',
            fontWeight: 400
        },
        '& .MuiTablePagination-selectLabel':{
            fontSize: '0.75rem',
            color:'#323232',
        },
        '& .MuiTablePagination-selectRoot':{
            '& svg':{
                marginTop: 3
            }
        },
        '& button':{
            padding:0,
            '&:hover':{
                background:'transparent'
            },
        }
    },
    displayRow:{
        '& span':{
            fontWeight: '700 !important'
        }
    },
    selectPopover:{
        '& .MuiPaper-root':{
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
            border: '1px solid #bbb',
            boxSizing:'border-box',
            '& *': {
                fontFamily: 'Pretendard !important',
            },
        },
        '& .MuiMenuItem-root':{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '0.875rem',
            color:'#323232',
            padding: '0 12px',
            boxSizing: 'border-box',
            height: 28,
            '&:hover':{
                background: '#eee'
            },
            '&.Mui-selected':{
                background: '#eee'
            },
            '&.Mui-disabled': {
                opacity: 1,
                '& svg':{
                    pointerEvents: 'auto'
                }
            },
        }
    },
    activeStepIcon: {
        width: '100%',
        padding: 0,
        marginTop: 5,
        '& .MuiStepIcon-active': {
            color: '#5579f0',
        },
        '& .MuiStepIcon-completed': {
            border: '1px solid #5579f0',
            borderRadius: '100%',
            color: '#fff'
        },
    },

    textBox: {
        '& .MuiBox-root': {
            padding: 0,
        }
    },
    tabBox: {
        position: 'relative',
        '& .MuiTabs-root':{
            minHeight: 40,
        },
        '& .MuiTab-root':{
            minWidth: 70,
        },
        '& .MuiTabs-flexContainer': {
            // width: 248,
            borderBottom: '1px solid #bbbbbb',
            borderRadius: 0,
            overflow: 'hidden'
        },
        '& button': {
            width: 160,
            minHeight: 48,
            height: 48,
            position: 'relative',
            fontSize: '1.063rem',
            fontWeight: 500,
            letterSpacing: '-0.5px',
            color:'#323232',
            boxSizing: 'border-box',
            padding:0,
        },
        '& button.Mui-selected': {
            fontWeight: 600,
            color: '#000',
            opacity: 1,
            boxSizing: 'border-box',
            background: 'transparent',
            borderRadius: 0
        },
        '& .MuiTabs-indicator':{
            height: 3,
            paddingBottom: 0,
            backgroundColor: '#000'
        },
        '& .MuiTab-wrapper': {
            alignItems: 'flex-start',
            paddingLeft: 10,
        }
    },
    setBtn: {
        position: 'absolute',
        right: 0,
        top: 0,
    },
    buttonStyle:{
        '&.MuiButtonBase-root': {
            width: 92,
            height: 36,
            padding: 0,
            minHeight: 36,
            background: '#fff',
            borderRadius: 4,
            marginLeft: 10,
            border: '1px solid #0097FF',
            boxSizing: 'border-box',
            '&:hover':{
                background: '#fff',
            },
            '& p':{
                fontSize: '0.875rem',
                color: '#0097FF',
                fontWeight: 700,
            },
            '&.Mui-disabled':{
                background: 'rgba(16, 18, 28, 0.30)',
                '& p':{
                    color: 'rgba(255, 255, 255, 0.70)'
                },
                '& path':{
                    stroke:'rgba(255, 255, 255, 0.70)'
                }
            }
        }
    },
    buttonStyle3:{
        '&.MuiButtonBase-root': {
            width: 70,
            background: '#10121C',
            marginLeft: 16,
            '& p':{
                marginLeft: 0
            },
            '&:hover':{
                background: '#10121C',
            },
        }
    },
    formControl:{
        '&.MuiFormControl-root ':{
            margin: 0,
        },
        '& .MuiSelect-select':{
            width: 240,
            height: 36,
            padding: '14px 25px 15px 12px !important',
            fontSize: '1.125rem',
            boxSizing:'border-box',
            color:'#777',
            letterSpacing: '-0.5px',
            display:'flex',
            alignItems: 'center',
            background: '#fff',
            border: 'solid 1px rgba(50, 50, 50, 0.8)',
            borderRadius: '6px !important',
            '@media all and (max-width: 800px)': {
                width: '100%',
            },
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiSelect-select':{
            border: '0px solid rgba(117, 0, 250, 0.4)',
            padding: '13px 25px 14px 12px !important',
        },
        '& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline':{
            border: 0,
            borderRadius: 6,
        },
        '& .MuiInput-underline:after, .MuiInput-underline:before': {
            border: 0,
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            border: 0,
        },
        '& .MuiSelect-icon': {
            top: 10,
            right: 6,
        }
    },
    formControlTime: {

        '& .MuiSelect-select':{
            width: 70,
            marginLeft: 10,
        }
    },
    textQuizBox: {
        '& .MuiFormControl-root': {
            width: 240,
            height: 36,
            boxSizing: 'border-box',
            background: '#fff',
        },
        '& .MuiOutlinedInput-root': {
            height: 40
        },
        '& .MuiOutlinedInput-input': {
            padding: '9px 10px',
        }
    },
    searchBox: {
        margin: '20px 0px'
    },
    iconButton:{
        '&.MuiIconButton-root': {
            width: 'auto',
            marginLeft: 15,
        },
        padding: '9px 14px',
        '&:hover':{
            background: 'transparent'
        }
    },
    popoverTooltip: {
        '& .MuiPopover-paper': {
            background: '#272727',
            color: '#fff',
            minWidth: 450,
            minHeight: 45,
            padding: '10px 10px 10px 15px',
            overflow: 'visible',
            marginLeft: 15,
        },
        '& .MuiTypography-root': {
            color: '#fff',
            fontSize: '15px',
            lineHeight: '21px',
            letterSpacing: '-0.5px',
        }
    },
    popoverTooltipBottom: {
        '& .MuiPopover-paper': {
            background: '#365edf',
            color: '#fff',
            minWidth: 400,
            minHeight: 66,
            padding: '10px 10px 10px 15px',
            overflow: 'visible',
            marginTop: 0,
        },
        '& .MuiTypography-root': {
            color: '#fff',
            fontSize: '15px',
            lineHeight: '21px',
            letterSpacing: '-0.5px',
        }
    },
    tooltipTop: {
        position: 'absolute',
        top: 20,
        left: '-13px',
        color: '#000'
    },
    tooltipBottom: {
        position: 'absolute',
        bottom: -15,
        left: '50%',
        color: '#000',
        '& svg': {
            transform: 'rotate(90deg)',
        }
    },
    tooltipBtn: {
        '& .MuiButtonBase-root': {
            padding: 0,
            minWidth: 'auto',
            '&:hover': {
                background: 'transparent'
            }
        }
    },
    iconBtn: {
        padding: 0,
        '&.MuiIconButton-root': {
            '&:hover': {
                background: 'transparent'
            }
        }

    },
    tooltip: {
        position: 'absolute',
        border: '1px solid #777',
        padding: '5px 5px 0 5px',
        background: '#fff',
    },





    selectText: {
        marginRight: 10,
        width: 135,
        '&.MuiTypography-root': {
            fontSize: '1.125rem',
            fontWeight: 500,
            '& span': {
                color: '#FF0000',
                fontWeight: 'bold'
            }
        },
    },

    bgBox: {
        '&.MuiBox-root': {
            padding: 20,
            background: '#fff',
            borderRadius: 10,
            border: '1px solid #e5e5e5',
        }
    },
    boxTitle: {
        '&.MuiTypography-root': {
            fontSize: '1.375rem',
            fontWeight: 500,
            marginBottom: 10,
            marginTop: 50,
        }
    },
    addBoxTitle: {
        marginBottom: 10,
        marginTop: 50,
        '& .MuiTypography-root': {
            fontSize: '1.375rem',
            fontWeight: 500,
        },
        '& .MuiButtonBase-root': {
            width: 112,
            height: 43,
            borderRadius: 7,
            background: '#0097FF',
            color: '#fff',
            marginRight: 40,
            '&:hover': {
                background: '#0097FF',
            },
        }
    },
    mainText: {
        '&.MuiTypography-root': {
            fontSize: '1.375rem',
            fontWeight: 500,
            marginRight: 20,
        }
    },
    subText: {
        '&.MuiTypography-root': {
            fontSize: '1.375rem',
            color: '#056CF2'
        }
    },

    setButton: {
        '&.MuiButtonBase-root': {
            border: '1px solid #0097FF',
            width: 112,
            height: 43,
            borderRadius: 7,
            marginRight: 20,
            '&:hover': {
                background: 'transparent'
            },
            '& .MuiTypography-root': {
                color: '#0097FF',
                fontWeight: 'bold',
                fontSize: '1.25rem'
            }
        }
    },
    preBtn: {
        '&.MuiButtonBase-root': {
            '&:hover': {
                background: 'transparent'
            }
        },
        '& svg': {
            marginRight: 10,
        },
        '& .MuiTypography-root': {
            fontSize: '1rem',
            fontWeight: 'bold',
        }
    },
    finishButton: {
        '&.MuiButtonBase-root': {
            background: '#7445FF',
            width: 130,
            height: 56,
            borderRadius: 7,
            '&:hover': {
                background: '#7445FF'
            },
            '& .MuiTypography-root': {
                color: '#fff',
                fontWeight: 'bold',
                fontSize: '1.25rem'
            }
        }
    },
    changeButton: {
        '&.MuiButtonBase-root': {
            background: '#fff',
            border: '1px solid #7445FF',
            width: 130,
            height: 56,
            borderRadius: 7,
            marginRight: 20,
            '&:hover': {
                background: '#fff'
            },
            '& .MuiTypography-root': {
                color: '#7445FF',
                fontWeight: 'bold',
                fontSize: '1.25rem'
            }
        }
    },
    swichStyle: {
        '&.MuiSwitch-root': {
            padding: '10px 10px',
            marginRight: 30,
        },
        '& .MuiSwitch-switchBase': {
            color: '#fff',
        },
        '& .MuiSwitch-thumb': {
            width: 14,
            height: 14,
        },
        '& .MuiButtonBase-root': {
            paddingTop: '12px',
            paddingLeft: '12px',
        },
        '& .MuiSwitch-track': {
            borderRadius: 10,
        },
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            background: '#5579f0',
            opacity: 1
        }
    },

    dialogWrap: {
        '& .MuiDialog-paperWidthSm': {
            maxWidth: 600,
            width: '100%',
            height: 305,
            padding: 30,
        }
    },
    titleDialog: {
        '& .MuiTypography-root': {
            fontSize: '1.563rem',
            fontWeight: 'bold',
        }
    },
    subDialog: {
        '& .MuiTypography-root': {
            fontSize: '1.25rem',
            color: '#616161',
            marginBottom: 10,
        }
    },
    inputBox: {
        marginTop: 20,
        '& .MuiFormControl-root': {
            width: '100%',
            height: 40,
            boxSizing: 'border-box',
            background: '#fff',
        },
        '& .MuiOutlinedInput-root': {
            height: 40
        },
        '& .MuiOutlinedInput-input': {
            padding: '9px 10px',
        }
    },
    groupBtn: {
        margin: '20px auto 0px',
    },
    inputButton: {
        '&.MuiButtonBase-root': {
            width: 350,
            background: '#d4d4d4',
            height: 44,
            '&:hover': {
                background: '#d4d4d4',
            }
        },
        '& .MuiTypography-root': {
            fontSize: '1.125rem',
            color: '#fff',
            fontWeight: 'bold',
        }
    },
    inputButtonActive: {
        '&.MuiButtonBase-root': {
            background: '#0097FF',
            '&:hover': {
                background: '#0097FF',
            }
        },
    },
    passwordNotice: {
        color: '#FF0000',
        fontSize: '0.875rem',
        marginTop: 10,
    },
    pic: {
        '&.MuiBox-root': {
            height: 57,
            marginRight: 30,
            '& svg': {
                width: 53,
                height: 53
            }
        }
    },
    groupNoticeBox: {
        marginTop: 10,
    },
    groupNoticeText: {
        color: '#FF0000',
        fontSize: '0.875rem',
        marginLeft: 5,
    },
    textInfo: {
        width: 240,
        color: '#333'
    },
    textInfoSet: {
        marginRight: 30,
        color: '#333'
    },
    groupInfoBox: {
        // marginTop: 30,
        marginBottom: 20,
    },
    groupInfo: {
        '&.MuiTypography-root': {
            fontSize: '1.375rem',
            fontWeight: 500,
        }
    },
    tooltipText: {
        padding: 10,
        borderRadius: 5,
        background: '#272727',
        color: '#fff',
    },
    imgSizeUp: {
        '&.MuiBox-root': {
            width: '100%',
            '& svg': {
                width: '100%',
                height: 'auto',
                border: '1px solid #777',
                padding: '5px 10px',
                background: '#fff',
            }
        },
    },
    popoverImg: {
        '& .MuiPopover-paper': {
            // minWidth: 200,
            // minHeight: 66,
            overflow: 'visible',
            marginTop: 0,
            boxShadow: 'none'
        },
    },
    threeGrid: {
        // maxWidth: '550px',
        width: '100%'
    },
    radioGroup: {
        '& .MuiRadio-colorSecondary.Mui-checked': {
            color: '#1554F6'
        },
        '& .MuiRadio-colorSecondary': {
            padding: 0,
            margin: 9,
            '&:hover': {
                background: 'transparent'
            }
        }
    },
    dueDayText: {
        fontSize: '0.8rem',
        // color: '#D4D4D4',
        color: '#333',
        marginBottom: 5,
    },
    noticeText: {
        fontSize: '0.8rem',
        color: '#FF0000',
        marginTop: 5,
    },
    datePicker: {
        '& input': {
            width: 220,
            height: 35,
            boxSizing: 'border-box',
            borderRadius: 6,
            border: '1px solid rgba(50, 50, 50, 0.8)',
            padding: '6px 7px 5px 30px',
            fontSize: '1rem',
        },
        '& input[type="date"]::-webkit-calendar-picker-indicator': {
            color: 'rgba(0, 0, 0, 0)',
            opacity: 1,
            display: 'block',
            background: 'url(../../common/images/GroupWarning.svg) no-repeat',
            width: 25,
            height: 25,
            borderWidth: 'thin'
        },
    },

}));

